import { IAttachment, IEmail } from '@dxp/core/models';

export function setBlankForAnchors(html: string) {
    const div = document.createElement('div');
    div.innerHTML = html;

    const links = div.querySelectorAll('a');
    links.forEach(link => (link.target = '_blank'));

    return div.innerHTML;
}

export function replaceCidImageSources(
    html: string,
    attachments: IAttachment[],
) {
    const div = document.createElement('div');
    div.innerHTML = html;
    const usedAttachments: IAttachment[] = [];

    const images = div.querySelectorAll('img');
    images.forEach(image => {
        if (image.src.startsWith('cid:')) {
            const fileName = image.src.replace('cid:', '').split('@')[0];
            const attachment = attachments.find(a =>
                a.contentUrl.includes(fileName),
            );
            if (attachment) {
                image.src = attachment.contentUrl;
                usedAttachments.push(attachment);
            }
        }
    });

    return {
        html: div.innerHTML,
        usedAttachments,
    };
}

export function createQuotedEmail(email: IEmail, signature?: string) {
    if (!email.body) {
        return '';
    }
    const root = document.createElement('div');
    const container = document.createElement('div');
    const separator = document.createElement('hr');

    container.innerHTML = signature || '';
    container.prepend(document.createElement('p'));
    container.appendChild(separator);

    const labelsDictionary = {
        From: `${email.from.name || ''} <${email.from.address}>`.trim(),
        Sent: new Date(email.creationDate).toLocaleString(),
        To: email.toRecipients
            .map(to => `${to.name || ''} <${to.address}>`.trim())
            .join('; '),
        Cc: email.ccRecipients
            .map(cc => `${cc.name || ''} <${cc.address}>`.trim())
            .join('; '),
        Bcc: email.bccRecipients
            .map(cc => `${cc.name || ''} <${cc.address}>`.trim())
            .join('; '),
        Subject: email.subject,
    };
    const labels = document.createElement('div');
    labels.style.cssText = 'font-size:11pt;font-family:Calibri,sans-serif';
    Object.entries(labelsDictionary)
        .filter(([, value]) => !!value)
        .forEach(([key, value]) => {
            const label = document.createElement('b');
            label.innerText = key + ': ';
            labels.appendChild(label);
            labels.append(value);
            labels.appendChild(document.createElement('br'));
        });

    container.appendChild(labels);
    container.appendChild(document.createElement('br'));

    const content = document.createElement('div');
    content.innerHTML = email.body.content;
    container.appendChild(content);

    root.appendChild(container);
    return root.innerHTML;
}

export function htmlTextToString(htmlStr: string): string {
    const span = document.createElement('span');
    span.innerHTML = htmlStr;

    const textContent = span.textContent || span.innerText;
    span.remove();

    return textContent;
}

export function getImageSources(htmlStr: string): string[] {
    const span = document.createElement('span');
    span.innerHTML = htmlStr;

    const imgs = span.querySelectorAll('img');
    span.remove();

    return Array.from(imgs).map(img => img.src);
}
